import React, { FC } from 'react';
import { IncontextIframe } from './IncontextIframe';

interface Props {
    sessionUuid: string;
    closeLoadingModal: () => void;
}

export const PaymentsIframe: FC<Props> = props => {
    return <IncontextIframe {...props} />;
};
